export default __webpack_public_path__ + "static/media/yantramanav.light.5dace5b8.ttf";